import { render, staticRenderFns } from "./CreateAndEditBag.vue?vue&type=template&id=c2d8f2e6&scoped=true"
import script from "./CreateAndEditBag.vue?vue&type=script&lang=js"
export * from "./CreateAndEditBag.vue?vue&type=script&lang=js"
import style0 from "./CreateAndEditBag.vue?vue&type=style&index=0&id=c2d8f2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8f2e6",
  null
  
)

export default component.exports